<!-- ICONS -->
<div class="position-fixed top-50 end-0 translate-middle-y zindex-tooltip">
    <div *ngFor="let icon of icons" class="icon-wrapper d-flex align-items-center position-relative"
        (click)="onIconClick(icon?.status)">
        <div class="icon-button text-white d-flex align-items-center justify-content-center relative"
            [ngStyle]="{ backgroundColor: icon?.color }">
            <span class="badge">{{ notificationUnreadCount }}</span>
            <i class="{{ icon.icon }} fs-5"></i>
        </div>

        <div class="tooltip-box text-white px-3" [ngStyle]="{ backgroundColor: icon?.color }">
            {{ icon.name }}
        </div>
    </div>
</div>

<!-- SIDEBAR -->
<p-sidebar class="p-sidebar-right" position="right" [(visible)]="isProgressReportNotification"
    header="Patient Progress Report Notification">

    <div class="d-flex justify-content-between align-items-center w-100 header-block">
        <span class="fw-bold">Pending Patient Progress Report</span>
        <button type="button" pButton pRipple icon="pi pi-times" class="p-button-rounded p-button-text"
            (click)="isProgressReportNotification = false">
        </button>
    </div>

    <div *ngIf="notificationData?.length > 0; else noNotifications">
        <div *ngFor="let notification of notificationData" class="d-flex align-items-start rounded"
            [class.bg-light]="!notification?.isReadDashboardNotification">
            <div class="flex-grow-1 cursor-pointer" (click)="navigateToProgressReport(notification)">
                <div class="fw-medium relative">
                    You have a pending progress report for <b>{{ notification?.patientName }}</b>.
                    <span *ngIf="!notification?.isReadDashboardNotification" class="new-notification"></span>
                </div>
                <div class="text-muted small">{{ notification?.createdTime }}</div>
            </div>
        </div>
    </div>

    <ng-template #noNotifications>
        <div class="text-center text-muted mt-4">No notifications found.</div>
    </ng-template>
</p-sidebar>